/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  UniV3FullRangeAdapter,
  UniV3FullRangeAdapterInterface,
} from "../../../contracts/adapters/UniV3FullRangeAdapter";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mintedAmount0",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mintedAmount1",
        type: "uint256",
      },
    ],
    name: "CapitalDeployed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "earnings0",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "earnings1",
        type: "uint256",
      },
    ],
    name: "EarningsSettled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "vault",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "pool",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidity",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
    ],
    name: "LiquidityRemoved",
    type: "event",
  },
  {
    inputs: [],
    name: "assetAddresses",
    outputs: [
      {
        internalType: "address",
        name: "token0",
        type: "address",
      },
      {
        internalType: "address",
        name: "token1",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "deployCapitalData",
        type: "bytes",
      },
    ],
    name: "deployCapital",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "depositTolerance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "side",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "removeLiquidityData",
        type: "bytes",
      },
    ],
    name: "earlyReturnCapital",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "earnings0",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "earnings1",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "estimatedHoldings",
    outputs: [
      {
        internalType: "uint256",
        name: "estimate0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "estimate1",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "factoryAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getEarnings",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "hasAccurateHoldings",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "holdings",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "id",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_id",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_pool",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_depositTolerance",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_unused",
        type: "bytes",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "liquidity",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pool",
    outputs: [
      {
        internalType: "contract IUniswapV3Pool",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "poolKey",
    outputs: [
      {
        internalType: "address",
        name: "token0",
        type: "address",
      },
      {
        internalType: "address",
        name: "token1",
        type: "address",
      },
      {
        internalType: "uint24",
        name: "fee",
        type: "uint24",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "poolMaxTick",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "poolMinTick",
    outputs: [
      {
        internalType: "int24",
        name: "",
        type: "int24",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "positionManager",
    outputs: [
      {
        internalType: "contract INonfungiblePositionManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "removeLiquidityData",
        type: "bytes",
      },
    ],
    name: "removeLiquidity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount1",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "side",
        type: "uint256",
      },
    ],
    name: "returnCapital",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_vaultAddress",
        type: "address",
      },
    ],
    name: "setVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "settleEarnings",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vaultAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type UniV3FullRangeAdapterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UniV3FullRangeAdapterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UniV3FullRangeAdapter__factory extends ContractFactory {
  constructor(...args: UniV3FullRangeAdapterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<UniV3FullRangeAdapter> {
    return super.deploy(overrides || {}) as Promise<UniV3FullRangeAdapter>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): UniV3FullRangeAdapter {
    return super.attach(address) as UniV3FullRangeAdapter;
  }
  override connect(signer: Signer): UniV3FullRangeAdapter__factory {
    return super.connect(signer) as UniV3FullRangeAdapter__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UniV3FullRangeAdapterInterface {
    return new utils.Interface(_abi) as UniV3FullRangeAdapterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UniV3FullRangeAdapter {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as UniV3FullRangeAdapter;
  }
}
